import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";
import EmployeeCard from "../employeeCard/employeeCard";
import { SidebarProps, EmployeeData } from "../../../models/monitorView/monitorViewTypes";
import { useAsyncThunkAction } from "../../../hooks/useAsyncThunkAction";
import { fetchSalaryPeriods, selectSalaryPeriods } from "../../../store/salaryPeriodSlice";
import { handleApiError } from "../../../models/store/storeEffects";
import { fetchSalaryRowTypes, selectSalaryRowTypes } from "../../../store/workShiftTimeSlotSlice";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";
import { MonitorViewFilters } from "../monitorViewFilters";
import { useFetch } from "../../../hooks/useFetch";
import { getEmployeeGroups } from "../../../services/employeeGroupService";
import { employeeGroupListItemDto } from "../../../models/employeeGroup/employeeGroup";
import VehicleGroupFilter from "./filters/vehicleGroupFilter";
import { setSelectedVehicleGroupIds } from "../../../store/monitorViewFiltersSlice";
import { Grid } from "@mui/material";

export const MonitorViewEmployees = ({
    data,
    selectedId: selectedEmployeeId,
    countByWorkTimeType,
    onSelect
}: SidebarProps<EmployeeData> & { onSelect: (id: string) => Promise<void> }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const salaryPeriods = useAppSelector(selectSalaryPeriods);
    const salaryRowTypes = useAppSelector(selectSalaryRowTypes);
    const [employeeGroups, setEmployeeGroups] = useState<employeeGroupListItemDto[]>();
    const selectedVehicleGroupIds = useAppSelector((state) => state.monitorViewFilters.selectedVehicleGroupIds);

    useAsyncThunkAction(
        () => fetchSalaryPeriods(),
        { onError: (e) => handleApiError(e, dispatch), },
        [],
        !salaryPeriods?.ids?.length
    );

    useAsyncThunkAction(
        () => fetchSalaryRowTypes(),
        { onError: (e) => handleApiError(e, dispatch), },
        [],
        !salaryRowTypes?.length
    );

    useFetch(
        (signal) => getEmployeeGroups(true, signal),
        {
            onSuccess: (res) =>
                setEmployeeGroups(
                    res.data.filter((d) => !!d.salaryPeriodTypeId)
                ),
        },
        []
    );

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <MonitorViewFilters countByWorkTimeType={countByWorkTimeType} />
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="flex-end">
                    <VehicleGroupFilter selectedGroupIds={selectedVehicleGroupIds} setSelectedVehicleGroupIds={setSelectedVehicleGroupIds} />
                </Grid>
            </Grid >
            {data?.length > 0 ? (
                data.map((e: EmployeeData) => (
                    <EmployeeCard
                        key={e.employeeId}
                        employee={e}
                        employeeGroups={employeeGroups}
                        isSelected={e.employeeId === selectedEmployeeId}
                        onClick={() => {
                            void onSelect(e.employeeId).catch((error) => {
                                console.error("Error selecting employee:", error);
                            });
                        }}
                    />
                ))
            ) : (
                <Alert variant="standard" severity="info">
                    {t("employee.noRows")}
                </Alert>
            )
            }
        </>
    );
};